import { useFormContext } from 'react-hook-form';
import { FormTextareaField, lt } from '@mews/framework';
import { Stack } from '@optimus-web/core';
import { RefundMode } from '@mews-commander/data-access';
import { TextKey } from '@mews-commander/enums';
import { PaymentAmountInputField } from '../../../common/PaymentAmountInputField';
import { PaymentRefundFormField } from '../types';
import { PaymentRefundFormValues } from '../schema';
import { PaymentTerminalSelectField } from '../../ProcessPayment/MewsTerminalPayment/PaymentTerminalSelectField';

export const PaymentRefundFormFields = ({ currencyCode }: { currencyCode: string }) => {
    const { getValues, trigger } = useFormContext<PaymentRefundFormValues>();

    const refundMode = getValues(PaymentRefundFormField.RefundMode);
    return (
        <Stack vertical spacing="300">
            <PaymentAmountInputField
                name={PaymentRefundFormField.Amount}
                currencyCode={currencyCode}
                onChange={() => void trigger(PaymentRefundFormField.Amount)}
            />
            {refundMode === RefundMode.InPerson ? (
                <PaymentTerminalSelectField
                    terminalFilter={(t) => t.isStripeTerminal}
                    helperTextKey={TextKey.InPersonRefundTerminalSelectionHint}
                />
            ) : null}
            <FormTextareaField name={PaymentRefundFormField.Notes} label={lt('Notes')} required rows={3} />
        </Stack>
    );
};
